import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useParams } from "react-router-dom";
import GenericTable from "../../components/0. Tablas/CursoTable";
import CursosView from "../../components/1.2 cursos/Curso";
import LoadingOverlay from "../../components/0. Utilidades/LoadingOverlay";

const CursoPage = () => {
  const { id } = useParams();
  const [selectedCurso, setSelectedCurso] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);

  useEffect(() => {
    if (id) {
      setLoadingDetail(true);
      fetch(`${process.env.REACT_APP_BASE_API}api/perfiles/cursos/${id}/`)
        .then((res) => res.json())
        .then((data) => {
          setSelectedCurso(data);
          setShowModal(true); // <-- ADD THIS
          setLoading(false);
        })
        .catch((err) => {
          console.error("Error:", err);
          setLoading(false);
        })
        .finally(() => setLoadingDetail(false));
    } else {
      setLoading(false);
    }
  }, [id]);

  const handleCursoSelect = (curso) => {
    setLoadingDetail(true);
    setShowModal(false);
    setSelectedCurso(null);

    fetch(`${process.env.REACT_APP_BASE_API}api/perfiles/cursos/${curso.id}/`)
      .then((res) => res.json())
      .then((data) => {
        setSelectedCurso(data);
        setShowModal(true);
      })
      .catch((err) => console.error("Error:", err))
      .finally(() => setLoadingDetail(false));
  };

  const columns = [
    { Header: "Nombre", accessor: "nombre" },
    { Header: "Comuna", accessor: "comuna" },
    { Header: "Oficio", accessor: "oficio" },
  ];

  if (loading) return <LoadingOverlay />;

  return (
    <>
      {(loading || loadingDetail) && <LoadingOverlay />}
      <div className="curso-page capsule">
        <GenericTable
          apiUrl={`${process.env.REACT_APP_BASE_API}api/perfiles/tabla/cursos/`}
          columns={columns}
          onRowClick={handleCursoSelect}
          category="cursos"
        />

        {showModal && selectedCurso && (
          <Modal
            show={showModal}
            onHide={() => setShowModal(false)}
            size="xl"
            backdrop="static"
            dialogClassName="modal-100w"
          >
            <Modal.Body className="curso-detail-modal position-relative">
              <button
                className="btn btn-sm btn-danger position-absolute top-0 end-0 m-3"
                onClick={() => setShowModal(false)}
              >
                &times;
              </button>
              <CursosView curso={selectedCurso} />
            </Modal.Body>
          </Modal>
        )}
      </div>
    </>
  );
};

export default CursoPage;
